/**
 * Remove selected post ids that no longer belong to any of the selected profiles.
 *
 * @param selection current selection, or 'all' when every post matching the filters is selected
 * @param postProfileIds map of post id -> profile id, collected from every post loaded so far
 * @param activeProfileIds profile ids of the currently selected profiles
 * @returns the pruned selection, or the same reference when nothing had to be dropped
 */
export function pruneSelectionByProfiles(
  selection: Record<string, boolean> | 'all',
  postProfileIds: Record<string, string>,
  activeProfileIds: string[]
): Record<string, boolean> {
  // NOTE: 'all' referred to the posts of the previously selected profiles, so it can't be kept
  if (selection === 'all') {
    return {}
  }

  const selectedIds = Object.keys(selection).filter(id => selection[id])
  const remaining = selectedIds.filter(id => {
    const profileId = postProfileIds[id]
    // EXPL: keep posts we never loaded a profile for, so an unrelated posts reset can't wipe the selection
    return profileId === undefined || activeProfileIds.includes(profileId)
  })

  if (remaining.length === selectedIds.length && remaining.length === Object.keys(selection).length) {
    return selection
  }

  return remaining.reduce((result: Record<string, boolean>, id) => {
    result[id] = true
    return result
  }, {})
}
